import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccountLayoutComponent } from './layout/account-layout.component';
import { AccountSideMenuComponent } from './side-menu/account-side-menu.component';
import { AccountSearchComponent } from './search/account-search.component';
import { AccountNavbarComponent } from './navbar/account-navbar.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AccountRouting } from './account.routing';
import { AccountDashboardComponent } from './dashboard/account-dashboard.component';
import { AccountLiveFeedComponent } from './live-feed/account-live-feed.component';
import { SharedModule } from '../shared/shared.module';
import { AccountSettingsModule } from './settings/account-settings.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { QuillModule } from 'ngx-quill';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AccountTrialBannerComponent } from './trial-banner/account-trial-banner.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MomentModule } from 'ngx-moment';
import { ChartistModule } from 'ng-chartist';

@NgModule({
  declarations: [
    AccountLayoutComponent,
    AccountSideMenuComponent,
    AccountSearchComponent,
    AccountNavbarComponent,
    AccountDashboardComponent,
    AccountLiveFeedComponent,
    AccountTrialBannerComponent,
  ],
  exports: [
    AccountLayoutComponent,
    AccountSideMenuComponent,
    AccountSearchComponent,
    AccountNavbarComponent,
    AccountDashboardComponent,
    AccountLiveFeedComponent,
    AccountTrialBannerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    AccountSettingsModule,
    QuillModule,
    ReactiveFormsModule,
    TypeaheadModule.forRoot(),
    AccountRouting,
    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    PaginationModule.forRoot(),
    FormsModule,
    MomentModule,
    ChartistModule,
    TooltipModule.forRoot(),
  ],
})
export class AccountModule {
  constructor(route: ActivatedRoute) {
    console.log('>>> Bootstrap AccountModule');
  }
}

console.log('account.module.ts');
